export default "__VITE_ASSET__CvB47kdU__"